import React from 'react';
import { Box } from '@mui/material';
import Navigation from './Navigation';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh' 
    }}>
      <Navigation />
      <Box component="main" sx={{ flexGrow: 1 }}>
        {children}
      </Box>
      {/* Footer */}
      <Box component="footer" sx={{ 
        textAlign: 'center', 
        py: 2, 
        mt: 'auto',
        color: 'text.secondary'
      }}>
        © {new Date().getFullYear()} Asureti. All rights reserved.
      </Box>
    </Box>
  );
};

export default Layout;
